import React from "react";

import Header from "../../components/Header";
import Footer from "../../components/Footer";
import GlobalCta from "../../components/global/GlobalCta";
import PageHero from "../../components/global/PageHero";
import ServiceOverview from "../../components/global/ServiceOverview";
import ServiceFeatures from "../../components/global/ServiceFeatures";
import ServiceChecks from "../../components/global/ServiceChecks";

const OVERVIEW = [
    "React Native lets us build genuinely native iOS and Android apps from a single JavaScript codebase. That means faster delivery, lower cost and a consistent experience across platforms.",
    "We build cross-platform apps that feel native — smooth navigation, real device features and performance users won't distinguish from a fully native build.",
];

const FEATURES = [
    { title: "Cross-platform, one codebase", text: "Ship to iOS and Android together, without maintaining two separate apps." },
    { title: "Native look and feel", text: "Real native components mean the app feels at home on every device." },
    { title: "Faster time to market", text: "Shared code and hot reloading get you to launch sooner." },
    { title: "Native device features", text: "Camera, location, notifications and more, wired in cleanly." },
];

const CHECKS = [
    "iOS & Android apps",
    "Cross-platform builds",
    "API & backend integration",
    "App store deployment",
    "Maintenance & updates",
];

export default function ReactNative() {
    return (
        <>
            <Header />

            <main>
                <PageHero eyebrow="Mobile" title="React Native Development" eyebrowAs="span">
                    One codebase, two platforms — native-quality iOS and Android apps built efficiently with React Native.
                </PageHero>
                <ServiceOverview paragraphs={OVERVIEW} />
                <ServiceFeatures items={FEATURES} />
                <ServiceChecks title="What's included" items={CHECKS} />
            </main>

            <GlobalCta />

            <Footer />
        </>
    );
}
